import { render, staticRenderFns } from "./JobDurationText.vue?vue&type=template&id=15f11a65&"
import script from "./JobDurationText.vue?vue&type=script&lang=ts&"
export * from "./JobDurationText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15f11a65')) {
      api.createRecord('15f11a65', component.options)
    } else {
      api.reload('15f11a65', component.options)
    }
    module.hot.accept("./JobDurationText.vue?vue&type=template&id=15f11a65&", function () {
      api.rerender('15f11a65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/job-duration-text/JobDurationText.vue"
export default component.exports